import { Spinner } from '@smartsheet/lodestar-core';
import React from 'react';

export function SmarSpinner() {
  return <Spinner className="smar-spinner" color={'#3576ba'} />;
}
